function updateHero(variantId, showImage = true) {
  document.querySelectorAll('[data-lf-hero]').forEach(hero => {
    const swatches = [...hero.querySelectorAll('.lf-swatch[data-lf-variant]')];
    const selected = swatches.find(swatch => swatch.dataset.lfVariant === variantId);
    if (!selected) return;

    swatches.forEach(swatch => {
      if (swatch === selected) swatch.setAttribute('aria-current', 'true');
      else swatch.removeAttribute('aria-current');
    });
    if (!showImage) return;

    const label = hero.querySelector('[data-lf-selected-colour]');
    if (label) {
      label.textContent = ` · ${selected.dataset.lfColourName}`;
      label.hidden = false;
    }
    const image = hero.querySelector('.lf-hero__bg img');
    if (image && selected.dataset.lfImage) {
      image.removeAttribute('srcset');
      image.src = selected.dataset.lfImage;
      image.alt = selected.dataset.lfImageAlt || selected.dataset.lfColourName;
      hero.classList.add('lf-hero--variant-selected');
    }
  });
}

function syncSelection() {
  const input = document.querySelector('main variant-picker input[data-variant-id]:checked');
  if (input) updateHero(input.dataset.variantId, new URLSearchParams(location.search).has('variant'));
}

document.addEventListener('click', event => {
  const swatch = event.target.closest?.('.lf-swatch[data-lf-variant]');
  if (!swatch || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const input = document.querySelector(`main variant-picker input[data-variant-id="${swatch.dataset.lfVariant}"]`);
  if (!input || input.disabled || !customElements.get('variant-picker')) return;

  event.preventDefault();
  updateHero(swatch.dataset.lfVariant);
  if (!input.checked) input.click();
});

document.addEventListener('change', event => {
  if (event.target.matches?.('main variant-picker input[data-variant-id]') && !event.target.closest('product-card, quick-add-dialog')) {
    updateHero(event.target.dataset.variantId);
  }
});
window.addEventListener('pageshow', syncSelection);
document.addEventListener('shopify:section:load', syncSelection);
syncSelection();
